import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './Home';
import UnderConstruction from './UnderConstruction';
import CountPage from './CountPage';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/underConstruction" element={<UnderConstruction />} />
        <Route path="/counter" element={<CountPage />} />
        <Route path="/reset" element={<CountPage />} />
      </Routes>
    </Router>
  );
}

export default App;
